import LegalPage from "./LegalPage";

export default function Privacy() {
  return (
    <LegalPage
      kicker="Legal"
      title="Privacy Policy"
      updated="Feb 2026"
      intro="PFAS Risk Intelligence (‘we’, ‘us’, ‘our’) is committed to protecting the personal information of the developers, landowners, planning consultants, contractors, councils, legal advisers, lenders, insurers and other professionals who use our website."
      sections={[
        { h: "Who we are",
          body: [
            "PFAS Risk Intelligence provides desk-based PFAS and brownfield risk intelligence for developers, landowners, planning consultants, contractors, councils, legal advisers, lenders and insurers in the United Kingdom.",
            "Website: pfasriskintelligence.co.uk · Email: info@pfasriskintelligence.co.uk",
          ] },
        { h: "What we collect",
          body: [
            "When you use the Triage Tool, download the Checklist, subscribe to PFAS Risk Watch or submit a Risk Screen enquiry, we collect the personal and professional information you provide:",
            ["Name, work email, mobile, company and role/buyer type",
             "Site postcode or location, site address, site type and proposed use (Risk Screen enquiries only)",
             "Your triage answers, resulting score and any message you submit",
             "Marketing consent status and the date/time of consent"],
            "We also automatically collect basic technical information (IP, browser user-agent) and, where present, UTM/tracking parameters passed with the form. We do not use invasive cookies or third-party tracking beyond what is needed to operate the site.",
          ] },
        { h: "Lawful basis",
          body: [
            "We process contact details and enquiry information on the basis of your consent (marketing) and legitimate interest (delivering the enquiry you have made, providing your requested content, and communicating about the service you have asked about).",
          ] },
        { h: "How we use your information",
          body: [
            "We use the information you provide to:",
            ["Deliver your triage result, checklist download or Risk Screen scoping conversation",
             "Send PFAS Risk Watch bulletins where you have subscribed",
             "Respond to your enquiries and provide fixed-fee Risk Screen services",
             "Improve the funnel, our content and our services"],
            "We do not sell your personal information. We do not currently share your data with any external CRM. When we introduce marketing automation or CRM in the future, we will update this policy first.",
          ] },
        { h: "Retention",
          body: [
            "We retain your enquiry and marketing data for as long as reasonably necessary to deliver the service you asked about, or while you remain subscribed to PFAS Risk Watch. You can request deletion at any time by emailing info@pfasriskintelligence.co.uk.",
          ] },
        { h: "Your rights",
          body: [
            "Under UK GDPR you have the right to access, correct, erase or restrict processing of your personal data, and to withdraw consent at any time. To exercise any of these rights, email info@pfasriskintelligence.co.uk.",
            "You also have the right to complain to the UK Information Commissioner’s Office (ico.org.uk).",
          ] },
        { h: "Security",
          body: [
            "Enquiry data is stored in a database with restricted admin access gated by allow-listed Google accounts. We use TLS in transit and follow reasonable technical measures to protect data at rest.",
          ] },
        { h: "Changes",
          body: [
            "We may update this policy from time to time. Material changes will be reflected in the ‘Last updated’ date.",
          ] },
      ]}
    />
  );
}
